import { render, staticRenderFns } from "./NewUseStatisManage.vue?vue&type=template&id=c7f2d7da&"
import script from "./NewUseStatisManage.vue?vue&type=script&lang=js&"
export * from "./NewUseStatisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports